(function($){
    window.Application = {
        ready: function () {
            this.Tabs.init();
            this.CurrencyField.init();
            this.Donate.ready();
        },
        Tabs: {
            init: function(){
                $('.js-tabs a').on('click',function(e){
                    e.preventDefault();
                    var $el = $(this),
                        $tab = $el.parent(),
                        $panelId = $tab.data('tab'),
                        $panel = $('#'+$panelId),
                        $clActive = 'active';
                    if(!$tab.hasClass($clActive)){
                        $tab.siblings('.'+$clActive).removeClass($clActive);
                        $tab.addClass($clActive);
                        $panel.siblings('.'+$clActive).removeClass($clActive);
                        $panel.addClass($clActive);
                    }
                });
            }
        },
        CurrencyField: {
            init: function(){
                $('.js-currency').each(function(){
                    var $input = $(this);
                    $input.inputmask({
                        min: $(this).attr('data-min'),
                        suffix: ' ' + $(this).attr('data-currency'),
                        groupSeparator: " ",
                        alias: "numeric",
                        digits: 0,
                        digitsOptional: !1,
                        showMaskOnFocus: false,
                        showMaskOnHover: false,
                        rightAlign: false,
                        oncleared: function(){ $input.trigger('inputmask-cleared'); },
                        onincomplete: function(){ $input.trigger('inputmask-incomplete'); },
                        oncomplete: function(){ $input.trigger('inputmask-complete'); }
                    });
                });
            }
        }
    };
})(jQuery);

// Initiate the application
jQuery(function () {
    Application.ready();
});